import {
  EvidencePlatformSidebarAppID,
  ProjectsSidebarAppFeatureId,
  OrganizationsSidebarAppFeatureId,
  UserRolesIdsEnum,
} from '@verantos-dev/core-enums';
import { SidebarApp, SidebarAppFeature } from '@verantos-dev/types-common';

/**
 * Sidebar App Features
 */
export const CohortsFeature: SidebarAppFeature = {
  featureId: ProjectsSidebarAppFeatureId.cohorts,
  featureName: 'Cohorts', // default is overriden by intl in hook
  priority: 1,
};

export const OrganizationsItem: SidebarAppFeature = {
  featureId: OrganizationsSidebarAppFeatureId.organizations,
  featureName: 'Organizations', // default is overridden by intl in hook
  priority: 1,
};

/**
 * Sidebar Apps
 */
export const PROJECTS_SIDEBAR_APP: SidebarApp = {
  sectionTitleId: 'projects',
  appId: EvidencePlatformSidebarAppID.projects,
  appName: EvidencePlatformSidebarAppID.projects,
  priority: 1,
  features: [CohortsFeature],
  additionalItems: [],
};

export const ANALYTICAL_VARIABLES_SIDEBAR_APP: SidebarApp = {
  appId: EvidencePlatformSidebarAppID.analyticalVariables,
  appName: EvidencePlatformSidebarAppID.analyticalVariables,
  priority: 2,
  features: [],
  additionalItems: [],
};

export const CONCEPT_GROUPS_SIDEBAR_APP: SidebarApp = {
  appId: EvidencePlatformSidebarAppID.conceptGroups,
  appName: EvidencePlatformSidebarAppID.conceptGroups,
  priority: 3,
  features: [],
  additionalItems: [],
};

// TODO: cleanup with data_reliability ff
export const DATA_RELIABILITY_SIDEBAR_APP: SidebarApp = {
  appId: EvidencePlatformSidebarAppID.dataReliability,
  appName: EvidencePlatformSidebarAppID.dataReliability,
  priority: 4,
  features: [],
  additionalItems: [],
};

// TODO: cleanup with research_assistant_developer_tools ff — OR-6432 Block B.
// Internal-only, project-independent RA session review tool. Gated on
// isInternalUser && research_assistant_developer_tools in useAllowedApps.ts;
// never reaches a customer regardless of flag state.
export const RA_SESSION_REVIEW_SIDEBAR_APP: SidebarApp = {
  appId: EvidencePlatformSidebarAppID.raSessionReview,
  appName: EvidencePlatformSidebarAppID.raSessionReview,
  priority: 5,
  features: [],
  additionalItems: [],
};

export const ORGANIZATIONS_SIDEBAR_APP: SidebarApp = {
  appId: EvidencePlatformSidebarAppID.organizations,
  appName: EvidencePlatformSidebarAppID.organizations,
  priority: 6,
  features: [],
  additionalItems: [],
};

export const USERS_SIDEBAR_APP: SidebarApp = {
  sectionTitleId: 'sysAdmin',
  appId: EvidencePlatformSidebarAppID.users,
  appName: EvidencePlatformSidebarAppID.users,
  // priority kept in sync with array position (after RA Session Review at 5).
  priority: 6,
  features: [],
  additionalItems: [OrganizationsItem],
};

export const EXTRACTION_ACCURACY_APP: SidebarApp = {
  sectionTitleId: 'extractionAccuracy',
  appId: EvidencePlatformSidebarAppID.extractionAccuracy,
  appName: EvidencePlatformSidebarAppID.extractionAccuracy,
  priority: 7,
  features: [],
  additionalItems: [],
};

export const SIDEBAR_APPS: SidebarApp[] = [
  PROJECTS_SIDEBAR_APP,
  ANALYTICAL_VARIABLES_SIDEBAR_APP,
  CONCEPT_GROUPS_SIDEBAR_APP,
  // TODO: cleanup with data_reliability ff
  DATA_RELIABILITY_SIDEBAR_APP,
  // TODO: cleanup with research_assistant_developer_tools ff
  RA_SESSION_REVIEW_SIDEBAR_APP,
  USERS_SIDEBAR_APP,
  EXTRACTION_ACCURACY_APP,
];

export const getVerantosApplicationDisplayNameForId = (appId: EvidencePlatformSidebarAppID) => {
  switch (appId) {
    case EvidencePlatformSidebarAppID.projects:
      return 'Projects';
    case EvidencePlatformSidebarAppID.organizations:
      return 'Organizations';
    case EvidencePlatformSidebarAppID.users:
      return 'Users';
    case EvidencePlatformSidebarAppID.conceptGroups:
      return 'Concept groups';
    case EvidencePlatformSidebarAppID.analyticalVariables:
      return 'Analytical variables';
    // TODO: cleanup with data_reliability ff
    case EvidencePlatformSidebarAppID.dataReliability:
      return 'Data Reliability';
    // TODO: cleanup with research_assistant_developer_tools ff
    case EvidencePlatformSidebarAppID.raSessionReview:
      return 'Session Review';
    default:
      return '';
  }
};

export const appIdToClaimCheckDefinitionMap: {
  [appId: string]: UserRolesIdsEnum;
} = {
  [EvidencePlatformSidebarAppID.projects]: UserRolesIdsEnum.OR_RESEARCHER,
  [EvidencePlatformSidebarAppID.organizations]: UserRolesIdsEnum.SA_ADMIN,
  [EvidencePlatformSidebarAppID.users]: UserRolesIdsEnum.SA_ADMIN,
  [EvidencePlatformSidebarAppID.extractionAccuracy]: UserRolesIdsEnum.VRN_DATA_ADMIN,
  [EvidencePlatformSidebarAppID.conceptGroups]: UserRolesIdsEnum.OR_RESEARCHER,
  [EvidencePlatformSidebarAppID.analyticalVariables]: UserRolesIdsEnum.OR_RESEARCHER,
  // TODO: cleanup with data_reliability ff
  [EvidencePlatformSidebarAppID.dataReliability]: UserRolesIdsEnum.OR_RESEARCHER,
};
